module.exports = __webpack_public_path__ + "static/media/Tea2.252fd869.svg";